import TabOptions from "modules/Common/Components/TabOptions";
import React from "react";
import TabsWrapper from "modules/Common/Components/TabsWrapper";
import { useLocation, useParams } from "react-router-dom";
import { PATH_ASSET, PATH_CAMPAIGNS, TAB_ASSET } from "constants/paths";

interface Props {}

export type PageParams = {
  page?: string;
  tab?: string;
  subTab?: string;
};

const AssetWithoutCampaignTab = (props: Props) => {
  const { tab } = useParams<PageParams>();
  const location = useLocation();

  /**
   *  tabsArray containing the titles and redirection links as well as isActive status based
   *  on the current :page param passed by props can be checked using useParams() hooks as well
   */

  const searchParams = new URLSearchParams(location.search);

  const tabsArray = [
    {
      pillName: "Dashboard",
      to: `/${PATH_CAMPAIGNS}/${PATH_ASSET}/?${searchParams}`,
      isActive: tab === undefined || tab === "/",
    },
    {
      pillName: "SmartSourced Content",
      to: `/${PATH_CAMPAIGNS}/${PATH_ASSET}/${TAB_ASSET.SOURCED_CONTENT}/?${searchParams}`,
      isActive: tab === TAB_ASSET.SOURCED_CONTENT,
    },
    {
      pillName: "Previously Sent",
      to: `/${PATH_CAMPAIGNS}/${PATH_ASSET}/${TAB_ASSET.PREVIOUSLY_SENT}/?${searchParams}`,
      isActive: tab === TAB_ASSET.PREVIOUSLY_SENT,
    },
    {
      pillName: "Audience",
      to: `/${PATH_CAMPAIGNS}/${PATH_ASSET}/${TAB_ASSET.AUDIENCE}/?${searchParams}`,
      isActive: tab === TAB_ASSET.AUDIENCE,
    },
  ];

  return (
    <div className="margin-bottom-sm margin-top-sm">
      <TabsWrapper>
        <TabOptions tabArray={tabsArray} />
      </TabsWrapper>
    </div>
  );
};

export default AssetWithoutCampaignTab;
